import axios from '../../../../../redux/my-axios';

export const BOXES_URL = '/boxes';

// READ
export function findBoxes(queryParams) {
  //console.log(queryParams);
  return axios.post(BOXES_URL, queryParams, { headers: { action: 'find' } });
}

export function getBox(boxCode) {
  return axios.post(BOXES_URL, boxCode, { headers: { action: 'select' } });
}

export function updateBox(boxForView) {
  return axios.post(BOXES_URL, boxForView, { headers: { action: 'put' } });
}
